import React from 'react';
import { Box, Typography, Stack, alpha } from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import { THEME_COLORS } from '../../shared/constants/theme';
import {
  DistributionCardShell,
  DistributionSimpleHeader,
  DistributionMetricTile,
  DistributionFooterActions,
  DistributionTotalBanner,
  DISTRIBUTION_ACCENT,
} from '../../utils/distributionCardParts';

export default function PmsInventoryCard({ inventory, isDark, onDelete }) {
  const totalRooms = inventory.total_rooms || 0;

  return (
    <DistributionCardShell isDark={isDark} maxHeight={360}>
      <DistributionSimpleHeader
        isDark={isDark}
        icon={InventoryIcon}
        title={inventory.room_type_name}
        chipLabel="PMS Inventory"
      />

      <Stack direction="row" spacing={1.25} sx={{ flexShrink: 0 }}>
        <DistributionMetricTile
          isDark={isDark}
          label="Total rooms"
          value={totalRooms}
          icon={MeetingRoomOutlinedIcon}
        />
      </Stack>

      <Box
        sx={{
          flex: 1,
          p: 1.25,
          borderRadius: 1.5,
          backgroundColor: isDark ? alpha(DISTRIBUTION_ACCENT, 0.08) : alpha(DISTRIBUTION_ACCENT, 0.06),
          border: `1px solid ${alpha(DISTRIBUTION_ACCENT, isDark ? 0.2 : 0.14)}`,
        }}
      >
        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: DISTRIBUTION_ACCENT, fontWeight: 600, lineHeight: 1.5 }}>
          Automatically calculated from rooms attached to this room type
        </Typography>
      </Box>

      <DistributionTotalBanner isDark={isDark} label="Available rooms" value={totalRooms} />

      <DistributionFooterActions isDark={isDark} onDelete={() => onDelete(inventory)} deleteTooltip="Delete inventory" />
    </DistributionCardShell>
  );
}
